import { ArrowDropDown, ArrowDropUp, Check, KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { Box, Checkbox, createTheme, Menu, MenuItem, ThemeProvider, Tooltip, Typography } from "@mui/material";
import { MouseEvent, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams, useSearchParams } from "react-router-dom";
import { SearchType } from "../../../model/ItemModel";

export interface ISearchboxSelect {
    setSelectedValue: (set: string) => void;
    selectedValue: string;
    setPersistedCheckboxOnDismount: (set: boolean) => void;
    persistedCheckboxOnDismount: boolean;
    setSearchType: (set: SearchType) => void;
    searchType: SearchType;
    setSearshName: (set: string) => void;
}

type SelectOptionsType = {
    txt: string;
    value: SearchType;
}

const theme = createTheme({
    components: {
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    backgroundColor: "#22638D",
                    color: "white",
                    height: "40px",
                    textAlign: "left",
                    font: " normal normal normal 14px Segoe UI",
                    opacity: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)"
                },
                arrow: {
                    color: "#22638D",
                },
            },
        },
    },
});

export const SearchboxSelect: React.FC<ISearchboxSelect> = ({
    setSelectedValue,
    selectedValue,
    persistedCheckboxOnDismount,
    setPersistedCheckboxOnDismount,
    setSearchType,
    searchType,
    setSearshName
}) => {

    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [isMouseEnter, setMouseEnter] = useState<boolean>(false);
    const [itemIdx, setItemIdx] = useState<number | undefined>(undefined);
    const [selectedText, setSelectedText] = useState<string>("");
    const { idWorkspace, nameOrg } = useParams();
    const open = Boolean(anchorEl);
    const [searchParams, setSearchParams] = useSearchParams();

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    function handleSelectedSearchType() {
        if (searchType == SearchType.FOLDER) {
            return t("SearchBox.inThatPage");
        } else if (searchType == SearchType.ONLYMYDOCUMENTS) {
            return t("SearchBox.myFolderAndFiles");
        } else if (searchType == SearchType.DEFAULT) {
            return t("SearchBox.default");
        } 
        return "";
    }

    useEffect(() => {
        setSelectedText(handleSelectedSearchType())
    }, [searchType])

    useEffect(() => {
        if (persistedCheckboxOnDismount) {
            if (searchType == SearchType.FOLDER) {
                setPersistedCheckboxOnDismount(false);
            }
        }
    }, [selectedValue])

    const selectOptions: SelectOptionsType[] = [
        {
            txt: t("SearchBox.myFolderAndFiles"),
            value: SearchType.ONLYMYDOCUMENTS
        },
        {
            txt: t("SearchBox.inThatPage"),
            value: SearchType.FOLDER
        },
        {
            txt: t("SearchBox.default"),
            value: SearchType.DEFAULT
        }
    ];

    function resetWorkspaceSearch() {
        searchParams.delete("search");
        searchParams.delete("tag");
        searchParams.delete("folder");
        searchParams.delete("contentSearch");
        searchParams.delete("searchType");
        searchParams.delete("bySearch");
        setSearchParams(searchParams);
        setSearshName("");
    }

    return (
        <>
            <Box
                onClick={(e: any) => handleClick(e as unknown as MouseEvent<HTMLButtonElement, globalThis.MouseEvent>)}
                component="div"
                sx={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    padding: "3px 8px",
                    borderRadius: "4px",
                    ":hover": {
                                color: "#22638D",
                                backgroundColor: "#E9EFF4",

                            }
                }}
            >
                <Typography
                    sx={{
                        fontFamily: "Segoe UI",
                        marginRight: "5px",
                        fontSize: "14px"
                    }}
                >
                    {selectedText}
                </Typography>
                {persistedCheckboxOnDismount && (
                    <ThemeProvider theme={theme}>
                        <Tooltip
                            title={t("SearchBox.searchForContent")}
                            arrow
                        >
                            <Typography
                                color='#22638D'
                            >
                                (+1)
                            </Typography>
                        </Tooltip>
                    </ThemeProvider>
                )}
                {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
            </Box>
            <Menu
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                MenuListProps={{
                    style: {
                        width: "202px",
                        padding: "0",
                        overflowY: "hidden"
                    }
                }}
                style={{
                    marginTop: "10px"
                }}
                anchorOrigin={{
                    horizontal: "right",
                    vertical: "bottom"
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
            >
                {selectOptions.map((item, idx) => (
                    <MenuItem
                        sx={{
                            borderBottom: "1px solid #dcdada",
                            display: "flex",
                            justifyContent: "space-between",
                            ":hover": {
                                color: "#22638D",
                                backgroundColor: "#E9EFF4",

                            }
                        }}
                        onClick={() => {
                            setSearchType(item.value);
                            resetWorkspaceSearch()
                        }}
                        disabled={
                            idx < 2 && idWorkspace == undefined ||
                            idx >= 2 && nameOrg == undefined
                        }
                        onMouseEnter={() => {
                            setMouseEnter(true);
                            setItemIdx(idx);
                        }}
                        onMouseLeave={() => {
                            setMouseEnter(false);
                            setItemIdx(undefined);
                        }}
                    >
                        <Typography
                            fontSize="14px"
                        >
                            {item.txt}
                        </Typography>
                        {Number(searchType) != idx && isMouseEnter && idx == itemIdx && <Check sx={{color: "#7aa2bb"}} fontSize="small" />}
                        {Number(searchType) == idx && <Check sx={{color: "#22638D"}} fontSize="small" />}
                    </MenuItem>
                ))}
            </Menu>
        </>
    )
}